{
  "home": {
    "title": "Panel de control",
    "welcome": "Bienvenido de nuevo, {{name}}",
    "guest": "Invitado",
    "subtitle": "Esto es lo que está pasando con su propiedad intelectual hoy.",
    "currentApplication": "Solicitud actual",
    "applicationProgress": "Progreso de la solicitud",
    "noActiveApplications": "Sin solicitudes activas",
    "createFirst": "Cree su primera solicitud de marca para comenzar.",
    "quickActions": "Acciones rápidas",
    "resumeFiling": "Presupuesto y pago",
    "resumeFilingDesc": "Vea su presupuesto y pague",
    "paymentHistory": "Historial de pagos",
    "paymentHistoryDesc": "Ver recibos y facturas",
    "contactSupport": "Contactar soporte",
    "contactSupportDesc": "Obtenga ayuda de nuestro equipo",
    "lastUpdated": "Última actualización: {{date}}",
    "newFiling": "Nueva verificación de marca",
    "viewAll": "Ver todo",
    "continueFiling": "Ver presupuesto y pago",
    "payAndFile": "Pagar y registrar",
    "viewQuoteStatus": "Ver estado",
    "viewFilingStatus": "Ver estado del registro",
    "activeFilings": "Solicitudes activas",
    "actionRequired": "Acción requerida",
    "protectedAssets": "Activos protegidos",
    "startProtecting": "Comience con una verificación gratuita de su marca en nuestro sitio web. Recibirá un informe detallado y un presupuesto confirmado por abogados en 24 horas, sin pago por adelantado.",
    "startNewApp": "Comience su verificación gratuita",
    "fromYourAttorney": "De su abogado de marcas",
    "unnamedTrademark": "Marca sin nombre",
    "insights": {
      "appInProgress": "Solicitud en progreso",
      "appInProgressMsg": "Revise su presupuesto y el estado del pago para avanzar con su solicitud.",
      "reportPreparing": "Su informe está en camino",
      "reportPreparingMsg": "Estamos preparando su informe de marca y presupuesto. Recibirá un correo en 24 horas.",
      "quoteReady": "Su presupuesto está listo",
      "quoteReadyMsg": "Su presupuesto confirmado por abogados está listo. Revíselo y pague para iniciar su registro.",
      "filingInProgress": "Registro en curso",
      "filingInProgressMsg": "Su pago se ha completado. Su solicitud de marca se está preparando para el registro.",
      "paymentPending": "Pago pendiente",
      "paymentPendingMsg": "Su solicitud está lista para registrar. Complete el pago para continuar.",
      "startJourney": "Comience su viaje",
      "startJourneyMsg": "Obtenga una verificación gratuita de su marca y un presupuesto en nuestro sitio web, sin pago por adelantado.",
      "analysisComplete": "Análisis completado",
      "analysisCompleteMsg": "Marko ha analizado su marca. Revise el informe para posibles conflictos.",
      "systemOp": "Sistema operativo",
      "systemOpMsg": "Todos los sistemas de monitoreo activos"
    }
  },
  "status": {
    "inProgress": "En progreso",
    "quoteRequested": "Preparando su informe",
    "quoteSent": "Presupuesto listo",
    "paymentPending": "Pago pendiente",
    "paymentComplete": "Pago completado",
    "pendingFiling": "Registro pendiente",
    "filingInProgress": "Registro en curso",
    "filed": "Registrada",
    "registered": "Concedida",
    "completed": "Completada",
    "cancelled": "Cancelada",
    "refunded": "Reembolsada",
    "partiallyRefunded": "Reembolso parcial"
  },
  "payments": {
    "sectionTitle": "Presupuesto y pago",
    "sectionSubtitle": "Revise su presupuesto, firme la declaración y complete el pago",
    "noApplicationTitle": "Aún no hay solicitud",
    "noApplicationMsg": "Comience con una verificación gratuita de su marca en nuestro sitio web. Le enviaremos por correo un informe detallado y un presupuesto en 24 horas.",
    "startFreeCheck": "Comience su verificación gratuita",
    "reportPreparingTitle": "Su informe se está preparando",
    "reportPreparingMsg": "Nuestro equipo está revisando su marca y preparando su informe detallado y presupuesto. Se lo enviaremos por correo en 24 horas.",
    "reportForTrademark": "Marca: {{name}}",
    "loadingQuote": "Cargando su presupuesto…",
    "noQuoteTitle": "Su presupuesto aún no está listo",
    "noQuoteMsg": "Todavía estamos finalizando el presupuesto de esta solicitud. Recibirá un correo en cuanto esté listo. Si cree que se trata de un error, responda a cualquiera de nuestros correos y lo resolveremos.",
    "quoteTitle": "Su presupuesto",
    "quoteSubtitle": "Revise las tarifas de registro y complete el pago",
    "quoteSubtitleConfirmed": "Confirmado por nuestros abogados: este es el importe exacto que se le cobrará.",
    "breakdown": "Desglose del presupuesto",
    "countries": "Países",
    "classes": "Clases",
    "serviceFee": "Tarifa de servicio",
    "governmentFees": "Tasas oficiales de registro",
    "filingFee": "Registro de marca",
    "discount": "Descuento por varios países",
    "total": "Total",
    "chargedIn": "Se cobra en {{currency}}",
    "pendingRetry": "Un intento de pago anterior está pendiente. Puede continuar e intentarlo de nuevo.",
    "attorneyServiceFee": "Honorarios del abogado de marcas",
    "quoteDocTitle": "Presupuesto",
    "dateOfIssue": "Fecha de emisión",
    "quoteValidity": "Válido por 30 días",
    "trademarkDetails": "Datos de la marca",
    "markName": "Marca",
    "markType": "Tipo",
    "applicant": "Solicitante",
    "viewFullReport": "Ver su informe completo",
    "hideFullReport": "Ocultar su informe completo",
    "reportExpanderHint": "El informe de marca que nuestro equipo preparó para usted",
    "settingUpPayment": "Preparando el pago seguro…",
    "paymentRetry": "Intentar de nuevo",
    "overlayUnlock": "Marque la declaración anterior para pagar",
    "overlayUnlockApplicant": "Añada los datos del solicitante arriba para pagar",
    "overlayUnlockBoth": "Añada los datos del solicitante y marque la declaración anterior para pagar",
    "applicantTbc": "Por confirmar",
    "applicantDetails": {
      "title": "Datos del solicitante",
      "subtitle": "La marca se registrará a este nombre. La oficina de marcas requiere el nombre y la dirección postal del solicitante para presentar la solicitud.",
      "nameLabel": "Nombre del solicitante",
      "namePlaceholder": "Nombre legal completo o razón social",
      "streetLabel": "Dirección (calle)",
      "streetPlaceholder": "Calle Ejemplo 123",
      "cityLabel": "Ciudad / Localidad",
      "stateLabel": "Estado / Provincia",
      "optional": "(opcional)",
      "zipLabel": "Código postal",
      "countryLabel": "País",
      "saving": "Guardando…",
      "saved": "Guardado",
      "saveError": "No se pudieron guardar sus datos. Se guardarán de nuevo mientras siga escribiendo."
    },
    "declaration": {
      "loading": "Cargando la declaración…",
      "title": "Autorización y declaración",
      "subtitle": "Obligatorio antes de que podamos presentar su solicitud de marca en su nombre",
      "combined": "Confirmo que estoy autorizado a registrar esta marca, que la información de esta solicitud es verdadera y exacta, y que designo a MarkoTM como mi agente para presentar y gestionar esta solicitud en mi nombre. Acepto los",
      "signedBy": "Firmado por",
      "signedOn": "el {{date}}",
      "saveError": "No se pudo guardar su declaración. Inténtelo de nuevo."
    },
    "report": {
      "title": "Su informe de marca",
      "subtitle": "Preparado por nuestro equipo",
      "preparedOn": "Preparado por nuestro equipo el {{date}}",
      "sections": {
        "overview": "Resumen",
        "markAssessment": "Evaluación de la marca",
        "registerFindings": "Resultados del registro",
        "coverageRationale": "Justificación de la cobertura",
        "ourRecommendation": "Nuestra recomendación",
        "nextSteps": "Próximos pasos"
      },
      "matchesTitle": "Resultados del registro de IP Australia",
      "matchName": "Marca",
      "matchNumber": "Número",
      "matchStatus": "Estado",
      "matchClasses": "Clases"
    }
  },
  "sidebar": {
    "dashboard": "Panel de control",
    "overview": "Resumen",
    "quoteAndPayment": "Presupuesto y pago",
    "quoteAndPaymentDesc": "Vea su presupuesto y pague",
    "myPortfolio": "Mi portafolio",
    "viewTrademarks": "Ver sus marcas",
    "renewals": "Renovaciones",
    "upcomingDeadlines": "Próximas fechas límite",
    "currentApplication": "Solicitud actual",
    "settings": "Configuración",
    "portfolio": "Mi portafolio",
    "newApplication": "Nueva solicitud",
    "filingProgress": "Progreso de registro",
    "documents": "Documentos",
    "billing": "Facturación"
  },
  "header": {
    "notifications": "Notificaciones",
    "profile": "Perfil",
    "logout": "Cerrar sesión"
  },
  "attorney": {
    "name": "Ken McInnes",
    "title": "Director de Estrategia de Marcas",
    "greeting": "Bienvenido a su panel seguro de PI. Aquí puede seguir el progreso de su marca y mantenerse fácilmente en contacto con su abogado de marcas asignado en cada paso."
  },
  "marko": {
    "analysisComplete": "¡He analizado su marca! Haga clic para ver mis recomendaciones.",
    "multiCountry": "¿Registrando en varios países? Le ayudaré a priorizar.",
    "thinking": "Marko está pensando...",
    "askMe": "Pregúnteme sobre marcas registradas",
    "clickToChat": "Haga clic para chatear →"
  },
  "application": {
    "create": "Crear solicitud",
    "createNew": "Crear nueva solicitud",
    "name": "Nombre de la solicitud",
    "namePlaceholder": "Dé un nombre a su solicitud de marca",
    "nameHelp": "Esto ayuda a organizar su portafolio de PI y seguir el progreso de su registro.",
    "delete": "Eliminar solicitud",
    "deleteConfirm": "¿Está seguro de que desea eliminar esta solicitud? Esta acción no se puede deshacer.",
    "status": "Estado de la solicitud",
    "progress": "Progreso"
  }
}
